// extracted by mini-css-extract-plugin
export default {"loginForm":"LoginForm_loginForm__-inUM","inputs":"LoginForm_inputs__SxmDF","loginBtn":"LoginForm_loginBtn__AGxrx"};